import { Client, fetchExchange } from "urql";

import { CONTENTFUL_GRAPHQL_API_URL } from "@/utils/urls.ts";

const getContentfulDeliveryKey = (): string | undefined => {
    return typeof window === "undefined"
        ? process.env["CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES"]
        : (window as unknown as Record<string, string>)[
              "CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES"
          ];
};

let contentfulGqlClient: Client;
export const getContentfulGqlClient = (): Client => {
    if (contentfulGqlClient) {
        return contentfulGqlClient;
    }

    const deliveryKey = getContentfulDeliveryKey();

    contentfulGqlClient = new Client({
        url: CONTENTFUL_GRAPHQL_API_URL,
        exchanges: [fetchExchange],
        fetchOptions: () => ({
            headers: {
                Authorization: `Bearer ${deliveryKey}`
            }
        })
    });

    return contentfulGqlClient;
};
